import { all, call, put, takeLatest } from "redux-saga/effects";
import { Action_SaveBanHang, Action_GetBanHangPrint } from "actions/BanHang/BanHang/actionTypes";
import { Index_SaveBanHangSuccess, Index_SaveBanHangFailed, Index_GetBanHangPrintSuccess } from "actions/BanHang/BanHang";
import banHangApi from "service/BanHangService/BanHangApi";
import { pushNotification } from "utils/notifications";

//Region api Lưu dữ liệu KHO
function* Saga_AddOrUpdateBanHang(action) {
  const response = yield call(banHangApi.addOrUpdateBanHang, action.payload);
  if (response.status == 200) {
    pushNotification("Lưu đơn hàng thành công", "success", "TOP_RIGHT", 2000);
    yield put(Index_SaveBanHangSuccess(response.data));
  } else {
    pushNotification(response.data, "error", "TOP_RIGHT", 2000);
    yield put(Index_SaveBanHangFailed(response.data));
  }
}

function* Saga_GetBanHangPrint(action) {
  const response = yield call(banHangApi.getBanHangById, action.payload);
  if (response.status == 200) {
    yield put(Index_GetBanHangPrintSuccess(response.data));
  } else {
    pushNotification(response.data, "error", "TOP_RIGHT", 2000);
  }
}
function* watch_AddOrUpdateBanHang() {
  yield takeLatest(Action_SaveBanHang, Saga_AddOrUpdateBanHang);
}
function* watch_GetBanHangPrint() {
  yield takeLatest(Action_GetBanHangPrint, Saga_GetBanHangPrint);
}
//endregion watchAPI

export default function* sagas() {
  yield all([watch_AddOrUpdateBanHang(), watch_GetBanHangPrint()]);
}
